import classNames from "classnames";
import React, { useCallback, useState } from "react";

import css from "./nested_tabs.module.scss";

export type Option<ID_TYPE extends string> = {
  id: ID_TYPE;
  value: string;
};

type NestedTabsProps<ID_TYPE extends string> = {
  defaultSelected?: ID_TYPE;
  options: Option<ID_TYPE>[];
  onChange: (id: ID_TYPE) => void;
};

/**
 * @deprecated Use Tabs instead
 */
const NestedTabs = <ID_TYPE extends string = string>({
  defaultSelected,
  options,
  onChange
}: NestedTabsProps<ID_TYPE>): JSX.Element => {
  const [selectedOption, setSelectedOption] = useState<ID_TYPE | undefined>(defaultSelected);
  const handleOnClick = useCallback((id: ID_TYPE) => {
    setSelectedOption(id);
    onChange(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={css.root}>
      {options.map(({ id, value }) => (
        <button
          key={id}
          className={classNames(css.button, { [css.selected]: selectedOption === id })}
          onClick={() => handleOnClick(id)}
        >
          {value}
        </button>
      ))}
    </div>
  );
};

export default NestedTabs;
